<sui-dialog-tabs>
  <ng-template suiDialogLeftHeader>
    @if (objectActionIcon) {
      <fa-icon [icon]="objectActionIcon"></fa-icon>
    }
    <h2 ngpDialogTitle>{{ objectActionTitle }}</h2>
  </ng-template>

  <ng-template suiDialogLeftContent>
    <app-search-input
      [placeholder]="'widget-settings-popup.search.search' | translate"
      (inputChanged)="onSearchInput($event)"
    ></app-search-input>

    <app-dialog-tab-nav
      [tabs]="visibleTabs"
      [activeId]="tabManager.activeTabId()"
      [invalidIds]="visibleInvalidTabIds"
      [invalidCounts]="visibleInvalidFieldCounts"
      (tabSelect)="tabManager.selectTab($event)"
    />
  </ng-template>

  <ng-template suiDialogRightHeader>
    <div class="right-header-content">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h2 ngpDialogDescription>{{ objectNameTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogRightContent>
    <div class="dialog-content">
      <div class="dialog-content__left-pane" data-sui-popover-boundary>
        <ng-container #tabHost></ng-container>
      </div>
      @if (
        !dialogData.massUpdate &&
        tabManager.activeTabId() !== "object_audit_trail"
      ) {
        <div class="dialog-content__right-pane" data-sui-popover-boundary>
          <div class="viz-types">
            @for (vizType of vizTypes$ | async; track vizType.id) {
              <div class="viz-type" (click)="selectVizType(vizType)">
                @if (loadingWidgetPreview) {
                  <app-loading></app-loading>
                }
                <app-widget-visualization-type-card
                  [chartTypeId]="vizType.id"
                  [selected]="vizType.id === chartTypeId"
                ></app-widget-visualization-type-card>
              </div>
            }
          </div>
          @if (widget) {
            <app-widget-card
              [widget]="widget"
              [widgetPreview]="true"
              (zoomChanged)="onZoomChanged($event)"
              [postCardViewConfig]="postCardViewConfig"
            ></app-widget-card>
          }
        </div>
      }
    </div>
  </ng-template>

  <ng-template suiDialogRightFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button variant="primary" (click)="save()">
      {{ "btn.update" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-tabs>
